import React, { memo } from "react";
import classnames from "classnames";
import deepEqual from "fast-deep-equal";

import { DeviceName } from "../../common/DeviceName";
import { Help } from "../../common/Help";
import { Tags } from "../../common/Tags";
import { IMetadataDataPoint } from "../utils/IMetadataDataPoint";
import {
    createDeviceReporter,
    skewChecker,
    statusChecker,
} from "./collectDeviceReport";
import * as styles from "./HealthModuleRow.scss";

const collectDeviceReport = createDeviceReporter(statusChecker, skewChecker);

export interface IHealthModuleRowProps {
    point: IMetadataDataPoint<"health">;
}

const HealthModuleRowFn = (props: IHealthModuleRowProps) => {
    const { point } = props;
    const { value, deviceId, tags } = point;

    const [displayStatus, deviceReport] = collectDeviceReport(point);

    return (
        <tr
            className={classnames(
                styles["health-module-row"],
                displayStatus === "offline" && styles.offline,
            )}
        >
            <td className={styles.health}>
                <div className={classnames(styles.chip, styles[displayStatus])}>
                    {deviceReport && (
                        <Help className={styles.help} text={deviceReport} />
                    )}
                </div>
            </td>
            <td className={styles.name}>
                <DeviceName
                    id={deviceId}
                    data-testid="health-module-device-name"
                />
            </td>
            <td className={styles.tags} data-testid="health-module-device-tags">
                <Tags tags={tags} />
            </td>
            <td
                className={styles.status}
                data-testid="health-module-device-status"
            >
                {value.status}
            </td>
        </tr>
    );
};

export const HealthModuleRow = memo(HealthModuleRowFn, deepEqual);
